module.exports = __webpack_public_path__ + "img/dashboard-desploy-blue.8b0aef1c.svg";